import React, {useContext} from 'react'
import { useFormData, useDependency, useInstanceSaver, useResourceFromPath } from 'hooks'
import {ControlledForm, ErrorBanner, PageContainer, PromiseButton} from 'components'
import Typography from '@material-ui/core/Typography'
import TextField from '@material-ui/core/TextField'

import { LogReferencesContext } from 'contexts'
import {errorStringsFromError} from 'utils'

const Form = () => {
  const {id, action} = useResourceFromPath()
  const log_references = useContext(LogReferencesContext.ReactContext)

  useDependency(() => {
    if(action === 'edit'){
      return log_references.actions.show(id)
    }
  }, [id, action])

  const [formData, setFormData] = useFormData(log_references.selected)
  const [save, errors] = useInstanceSaver(formData, log_references, action)

  return (
    <PageContainer>
      <Typography variant='h5'>{action === 'edit' ? `Edit Reference - ${formData.name}` : 'Create a new Reference'}</Typography>
      <ControlledForm data={formData} errors={errors} onChange={setFormData} onSubmit={save}>
        <ErrorBanner>{errorStringsFromError(log_references.actions.apiErrorsFor('create', 'update'))}</ErrorBanner>
        <TextField fullWidth name='name'/>
      <PromiseButton color='secondary' fullWidth variant='contained' type='submit'>Save</PromiseButton>
      </ControlledForm>
    </PageContainer>
  )
}

export default (props) => (
  <LogReferencesContext>
    <Form {...props} />
  </LogReferencesContext>
)